let Reviews = {
	init: function(){
		jQuery('#slick-slider').slick({
			dots: true,
			arrows: true,
			adaptiveHeight: true,
			prevArrow: '<i class="fa fa-chevron-left slick-prev"></i>',
			nextArrow: '<i class="fa fa-chevron-right rev-slick-next slick-next"></i>', 
			appendArrows: '#slider-nav',
			appendDots: '#slider-nav'
		});

		jQuery('.rev-slick-next').detach().insertAfter('#slider-nav .slick-dots');
		jQuery('#slick-wrapper').removeAttr('style');
	}
}